var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M16.3078 8.06981C16.3078 7.71731 16.0301 7.4248 15.6793 7.4248H2.32084C1.97008 7.4248 1.69238 7.70981 1.69238 8.06981C1.69238 12.4873 4.69584 15.5698 9.00008 15.5698C13.3043 15.5698 16.3078 12.4798 16.3078 8.06981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.38722 2.59482L11.4699 4.72482C11.6818 4.94232 11.6818 5.30232 11.4699 5.51982C11.258 5.73732 10.9072 5.73732 10.6953 5.51982L9.54799 4.34982V11.5273C9.54799 11.8348 9.29953 12.0898 8.99991 12.0898C8.70029 12.0898 8.45183 11.8348 8.45183 11.5273V4.34982L7.31183 5.52732C7.09991 5.74482 6.74914 5.74482 6.53722 5.52732C6.4276 5.41482 6.36914 5.27232 6.36914 5.12982C6.36914 4.98732 6.42029 4.84482 6.52991 4.73232L8.6126 2.60232C8.82453 2.37732 9.17529 2.37732 9.38722 2.59482Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.689c50b0156024b8bd17280409a56287.svg";
export { ForwardRef as ReactComponent };